export default __webpack_public_path__ + "static/src/assets/images/icons/changepassword_fail.png";